import { Color } from 'shared/utils/colors';

export const LOADING_SX = {
  width: '100%',
  height: '100%',
  minHeight: '400px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: Color.slateGray,
  padding: '20px',
};

export const CONTAINER_SX = {
  width: '100%',
  height: '100%',
  overflow: 'auto',
  backgroundColor: Color.slateGray,
  padding: '20px',
};

export const PAGES_WRAPPER_SX = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '20px',
};

export const getPageSx = (rendered?: boolean) => ({
  position: 'relative',
  backgroundColor: rendered ? 'white' : Color.slateGray,
  boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  minHeight: '400px',
});

export const PAGE_OVERLAY_SX = {
  position: 'absolute',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  height: '100%',
  backgroundColor: 'rgba(151,151,151,0.55)',
};

export const getCanvasStyle = (rendered?: boolean) => ({
  display: 'block',
  opacity: rendered ? 1 : 0,
  transition: 'opacity 0.3s',
});
